import type { ReactElement, SVGProps } from 'react'

export function TypeMarkKatana(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg viewBox={'0 0 577.33 131.11'} fill={'none'} {...props}>
      <image href={'/katana-typemark.svg'} width={'577.33'} height={'131.11'} preserveAspectRatio={'xMidYMid meet'} />
    </svg>
  )
}
